var exports = {
  "XS": "SignUpForm__VDbyAG",
  "N3": "SignUpForm__field__4ZUM6t",
  "Pl": "SignUpForm__label__YNowRe",
  "P6": "SignUpForm__input__JlFC3S",
  "f5": "SignUpForm__submit__SOEuG7",
};

module.exports = exports;
